import React, { useState } from 'react';
import ConfigForm from './ConfigForm';
import ConfigDisplay from './ConfigDisplay';
import DeploymentGuide from './DeploymentGuide';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Dashboard() {
  const [configs, setConfigs] = useState([]);
  const [activeTab, setActiveTab] = useState('generator');
  const [lastUuid, setLastUuid] = useState('');

  const handleGenerate = (newConfig) => {
    setConfigs(prev => [newConfig, ...prev]);
    // Extract UUID from config string if possible (simple regex for demo)
    const uuidMatch = newConfig.string.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
    if (uuidMatch) setLastUuid(uuidMatch[0]);
  };

  const handleRemove = (index) => {
    setConfigs(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-gray-200 p-4 md:p-8 font-sans">
      <div className="max-w-6xl mx-auto">
        <header className="mb-10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500 flex items-center gap-3">
              <SafeIcon icon={FiIcons.FiShield} className="text-cyan-500" />
              Nexus Proxy Hub
            </h1>
            <p className="text-gray-400 mt-2">Cloudflare Pages / US-West Edge Generator</p>
          </div>
          
          <div className="flex bg-gray-800 p-1 rounded-xl border border-gray-700">
            <button 
              onClick={() => setActiveTab('generator')}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'generator' ? 'bg-cyan-600 text-white shadow-lg' : 'text-gray-400 hover:text-white'}`}
            >
              Config Generator
            </button>
            <button 
              onClick={() => setActiveTab('deployment')}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${activeTab === 'deployment' ? 'bg-cyan-600 text-white shadow-lg' : 'text-gray-400 hover:text-white'}`}
            >
              Server Deployment
            </button>
          </div>
        </header>

        {activeTab === 'generator' ? (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 animate-in fade-in duration-500">
            <div className="lg:col-span-7">
              <div className="mb-6">
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <SafeIcon icon={FiIcons.FiSettings} /> Configure Endpoint
                </h2>
                <ConfigForm onGenerate={handleGenerate} />
              </div>
            </div>

            <div className="lg:col-span-5">
              <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                <SafeIcon icon={FiIcons.FiList} /> Generated Configs
              </h2>
              
              {configs.length === 0 ? (
                <div className="bg-gray-800/50 border border-gray-700/50 border-dashed rounded-xl p-8 text-center text-gray-500 flex flex-col items-center justify-center">
                  <SafeIcon icon={FiIcons.FiInbox} size={48} className="mb-4 opacity-50" />
                  <p>No configurations yet.</p>
                </div>
              ) : (
                <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2 custom-scrollbar">
                  {configs.map((config, idx) => (
                    <ConfigDisplay 
                      key={idx} 
                      config={config} 
                      onRemove={() => handleRemove(idx)} 
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="max-w-3xl mx-auto animate-in slide-in-from-bottom-4 duration-500">
            <DeploymentGuide uuid={lastUuid} />
          </div>
        )}
      </div>
    </div>
  );
}